//
// Module for Maintenance Task Index view
//
rs.module("content/system_/configuration/maintenancetasks/index",

    [ /* dependencies */],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {
            var selectTaskForm = $.js(jsSelectors.selectTaskForm);

            selectTaskForm.js(jsSelectors.taskSelect).change(function () {
                this.form.submit();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);